export const mandate = {
    data: {
        type: "mandateDetailsResponseDao",
        lst: [
            {
                APPROVEDDATE: "",
                IFSCCODE: "ICIC0000037",
                accountNumber: "003701071426",
                amount: "50000.00",
                bankName: "ICICI BANK LTD",
                branch: "PREET VIHAR BRANCH F - 11 PREET VIHAR NE",
                clientCode: "80186353",
                clientName: "ANSHUL  JAIN",
                clientstatus: "",
                createdBy: "80186353",
                createdOn: "4/28/2023 3:21:42 PM",
                dateofreceived: "",
                filler1: "MFI",
                filler2: "",
                filler3: "",
                filler4: "",
                filler5: "",
                filler6: "",
                isAuthenticate: false,
                isPending: false,
                listId: "2012763",
                mandateDate: "",
                c: "19583194",
                mandateMode: "MFI",
                mandateStatus: "Approved",
                mandateType: "X",
                memberId: "",
                modeOfPayment: "",
                pdfContent: "System.Byte[]",
                remark: "",
                remarks: "ASSIGNED TO RCB",
                shortName: "ICICI",
                status: "SCAN IMAGE NOT UPLOADED",
                updatedBy: "80186353",
                updatedOn: "4/28/2023 3:21:42 PM",
            },
            {
                APPROVEDDATE: "",
                IFSCCODE: "ICIC0000037",
                accountNumber: "003701071426",
                amount: "50000.00",
                bankName: "HDFC BANK LTD",
                branch: "PREET VIHAR BRANCH F - 11 PREET VIHAR NE",
                clientCode: "80186353",
                clientName: "ANSHUL  JAIN",
                clientstatus: "",
                createdBy: "80186353",
                createdOn: "3/6/2023 5:57:06 PM",
                dateofreceived: "",
                filler1: "MFI",
                filler2: "",
                filler3: "",
                filler4: "",
                filler5: "",
                filler6: "",
                isAuthenticate: false,
                isPending: false,
                listId: "2012045",
                mandateDate: "",
                mandateId: "17345512",
                mandateMode: "MFI",
                mandateStatus: "Not Approved",
                mandateType: "X",
                memberId: "",
                modeOfPayment: "",
                pdfContent: "System.Byte[]",
                remark: "",
                remarks: "ASSIGNED TO RCB",
                shortName: "ICICI",
                status: "SCAN IMAGE NOT UPLOADED",
                updatedBy: "80186353",
                updatedOn: "3/6/2023 5:57:06 PM",
            },
        ],
    },
};
export const mfBankdetails = {
    data: {
        type: "bankDetailsResponseDao",
        aldMndTypes: ["X"],
        lst: [
            {
                bnkAcNo: "50100443898542",
                bnkNm: "HDFC BANK LTD",
                brn: "TULASI CHAMBERS NO 529 NEAR MASTIKATTA BAZAR ROAD HONAVAR UT, UTTAR KANNAD",
                def: true,
                ifscCode: "HDFC0004156",
            },
            {
                bnkAcNo: "20329136247",
                bnkNm: "STATE BANK OF INDIA",
                brn: "TULASI CHAMBERS NO 529 NEAR MASTIKATTA BAZAR ROAD HONAVAR UT, UTTAR KANNAD",
                def: false,
                ifscCode: "SBIN0000569",
            },
        ],
    },
};
export const uploadImage = {
    img: "iimage.jpg",
    imgnm: "",
};
export const downloadMandate = {
    data: "",
};
export const calendardummydata = {
    data: {
        type: "mandateCalendarResponseDao",
        mndtBalance: [
            {
                amount: "3456",
                balanceAmount: "222",
                mandateID: "0",
                monthDate: "21-Jun-23 12:00:00 AM",
                usedAmount: "4",
            },
            {
                amount: "3456",
                balanceAmount: "222",
                mandateID: "0",
                monthDate: "21-Jun-23 12:00:00 AM",
                usedAmount: "4",
            },
        ],
    },
};
export const mandateSwitch = {
    "appID": "663051cfbac7d699a1c59b96048b50e7",
    "config": {
        "app": 1,
        "exp": 1692578722783,
        "info": 14
    },
    "data": {
        "type": "mandateTypesResponseDao",
        "digital": false,
        "physical": true
    },
    "msgID": "b6342458-95b6-4e18-bb2d-ca664b39582b",
    "srvTm": 1692591000549
};
export const emandateUrl = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1700438414838,
        "info": 4
    },
    "data": {
        "type": "dionResponseDao",
        "aawid": 0,
        "errorCode": 0,
        "message": "https://app.digio.in/#/gateway/login/ENA23112017543642753Q4U7JY4TM4AP/vI3atY/shrivastavashantanu1999@gmail.com?redirect_url=https%3A%2F%2Fwww.bsestarmf.in%2FENACHResponse.aspx&logo=https%3A%2F%2Fwww.bsestarmf.in%2Fimages%2Fbsestarmfnew.jpg",
        "status": "100",
        "statusCode": "100"
    },
    "msgID": "69381c4b-4d34-4fa4-93f9-17c314a744b9",
    "srvTm": 1700483077585
};
